export default class ChangelogsManagement {
    id: number;
    version: string;
    date: string;

    constructor(id: number, version: string, date: string) {
        this.id = id;
        this.version = version;
        this.date = date;
    }
}